import React, { useState, useEffect, useCallback } from "react";
import { Link } from 'react-router-dom';
import authLayout from "../hoc/authLayout";
import logoimage from "../img/hero-slider/favicon.png";
import faviconimg from "../img/hero-slider/favicon.png";
import imgawards from "../img/an-awards-image-2.png";
import imgreview1 from "../img/review/1.jpg";
import imgreview2 from "../img/review/2.jpg";
import imgreview3 from "../img/review/3.jpg";
import imgreview4 from "../img/review/4.jpg";
import imgreview5 from "../img/review/5.jpg";
import imgreview6 from "../img/review/6.jpg";
import imgwhatsapp from "../img/hero-slider/whatsapp.png";
import axios from "axios";
import baseURL from "../common/base-urls.js";
import '../css/bootstrap.min.css';
import '../css/main.css';
import '../css/theme-dark.css';
import '../css/new.css';
// import '../js/jquery-3.5.1.min.js';
// import '../js/aos.js';
// import '../js/swiper-bundle.min.js';
// import '../js/main.js';
import debounce from "lodash/debounce";
import useSWR, { mutate } from "swr";
import { useNavigate, useLocation } from "react-router-dom";
const SingleProject = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [apiUrl, setApiUrl] = useState('');
    const [apiUpcomingUrl, setUpcomingApiUrl] = useState('');
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(10);
    //#region ====================================================== Create State =====================================================
    const [state, setState] = useState({
        delete_id: "0",
        lblpagedisplay: 0,
        total_pages: 0,
        pagination: [],
        show_filter: false,
        filter_applied: false,
        show_toast: false,
        toast_msg: "No record found",
        show_modal: false,
        modal_title: "Confirmation",
        modal_msg:
            "Are you absolutely certain you want to delete this record? This action cannot be reversed.",
        modal_button: "Delete",
    });
    //#endregion
    //#region ====================================================== Update State ======================================================
    const updateState = (key, value) => {
        setState((prevState) => ({
            ...prevState,
            [key]: value,
        }));
    };
    //#endregion 
    //#region ====================================================== Page Table Bind Data ======================================================
    let tbldata = {};
    const projectId = location.state?.editid;
    let tblupcomingdata = {};
    let tblpagination = {};
    useEffect(() => {
        if (!projectId) return;
        const newApiUrl = `projects/${projectId}`;
        setApiUrl(newApiUrl);


    }, []);
    const { data, error, isValidating } = useSWR(
        apiUrl,
        () => getAPI(apiUrl, false),
        {
            revalidateOnReconnect: false,
            revalidateOnFocus: false,
        }
    );
    tbldata = data;
    //#endregion
    //#region ====================================================== Pagination & Page Changed ======================================================
    useEffect(() => {
        try {
            if (tbldata && tbldata.data && tbldata.data.hasOwnProperty("count") && tbldata.data.count > 0) {
                let dblPageCount = Math.ceil(parseInt(tbldata.data.count) / limit);
                let pageCount = Math.max(1, dblPageCount);
                updateState("total_pages", pageCount);
                let rows = [];
                if (pageCount > 0) {
                    for (let i = 1; i <= pageCount; i++) {
                        if (i == 1 || i == pageCount) {
                            rows.push({ text: i.toString(), value: i.toString(), enabled: i != parseInt(page) });
                        }
                        else if ((i >= parseInt(page) - 2) && (i <= parseInt(page) + 3)) {
                            rows.push({ text: i.toString(), value: i.toString(), enabled: i != parseInt(page) });
                        }
                        else if (((i > parseInt(page) + 3) && (i >= pageCount - 2))) {
                            rows.push({ text: i.toString(), value: i.toString(), enabled: i != parseInt(page) });
                        }
                    }
                } else {
                    pageCount = '0';
                }
                setState((prevState) => ({
                    ...prevState,
                    pagination: rows
                }));
                tblpagination = rows;
                let firstpage = 1;
                let lastpage = 1;
                if (parseInt(page) === 1) {
                    if (limit * parseInt(page) <= parseInt(tbldata.data.count)) {
                        firstpage = 1;
                        lastpage = limit;
                    } else {
                        firstpage = 1;
                        lastpage = parseInt(tbldata.data.count);
                    }
                } else {
                    if (limit * parseInt(page) <= parseInt(tbldata.data.count)) {
                        firstpage = limit * (parseInt(page) - 1) + 1;
                        lastpage = limit * parseInt(page);
                    } else {
                        lastpage = parseInt(tbldata.data.count);
                        firstpage = limit * (parseInt(page) - 1) + 1;
                    }
                }
                updateState("lblpagedisplay", tbldata.data.count !== '0' ? `${firstpage} - ${lastpage}` : '0 - 0');
                if (lastpage === 0) {
                    firstpage = 0;
                    updateState("lblpagedisplay", tbldata.data.count !== '0' ? `${firstpage} - ${lastpage}` : '0 - 0');
                }
            }
        } catch (ex) {
        }
    }, [data]);
    const handlePageChange = (newPage) => {
        setPage(newPage);
    };
    //#endregion  
    const validProjectIds = [1, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24];
    const getValidProjectId = (projectId) => {
        if (projectId < 1 || projectId === 2 || projectId > 24) {
            return 3;
        }
        return projectId;
    };

    const getNextValidId = (currentId) => {
        const currentIndex = validProjectIds.indexOf(currentId);
        if (currentIndex === -1 || currentIndex === validProjectIds.length - 1) {
            return validProjectIds[0]; // or return currentId to stay on current
        }
        return validProjectIds[currentIndex + 1];
    };

    const getPreviousValidId = (currentId) => {
        const currentIndex = validProjectIds.indexOf(currentId);
        if (currentIndex <= 0) {
            return validProjectIds[0]; // or return currentId to stay on current
        }
        return validProjectIds[currentIndex - 1];
    };

    const editRecord = (projectId) => {
        try {
            projectId = getValidProjectId(projectId);
            // navigate(`/project/${projectId}`);

            // navigate("/project", { state: { editid: projectId } });
            if (!projectId) return;
            const newApiUrl = `projects/${projectId}`;
            setApiUrl(newApiUrl);
        } catch (err) {
            console.error("Navigation error:", err);
        }
    };


    const debouncedEditRecord = debounce((projectId) => {
        editRecord(projectId);
    }, 500);


    //#endregion 
    //#region ====================================================== Get API ======================================================
    const getAPI = async (url, Auth) => {
        try {

            const response = await axios.get(`${baseURL.serverUrl}${url}`, {
                headers: {
                },
            });
            return response.data;

        } catch (err) {
            return {};
        }
    };
    //#endregion 
    useEffect(() => {
        document.querySelectorAll('a[href^="/"], a[href^="#"]').forEach(anchor => {
            anchor.addEventListener('click', function (e) {
                e.preventDefault();

                const href = this.getAttribute('href');
                const id = href.startsWith('#') ? href.substring(1) : href; // Remove the leading slash or hash

                if (id === '/privacy' || id === '/terms') {
                    // Navigate to privacy or terms page
                    window.location.href = window.location.origin + '#/' + id.substring(1);
                    // Scroll to the top of the page
                    window.scrollTo({
                        top: 0,
                        behavior: 'smooth'
                    });
                }
                else if (id === '/') {
                    // Navigate to privacy or terms page
                    window.location.href = window.location.origin;
                    // Scroll to the top of the page
                    window.scrollTo({
                        top: 0,
                        behavior: 'smooth'
                    });
                }
                else if (id !== '') {
                    // Scroll to the element with the corresponding ID
                    const element = document.getElementById(id);
                    if (element) {
                        element.scrollIntoView({
                            behavior: 'smooth'
                        });
                    }
                } else {
                    // Handle routing for React Router links
                    window.location.href = href;
                }
            });
        });
    }, []);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        const handleContextMenu = (e) => {
            e.preventDefault();
        };
        document.addEventListener('contextmenu', handleContextMenu);

        return () => {
            document.removeEventListener('contextmenu', handleContextMenu);
        };
    }, []);


    return (
        <>
            <>
                <style>{`
        .layer {
          background-color: rgb(69 156 153 / 54%);
          position: absolute;
          top: 0;
          left: 0;
          background: linear-gradient(to right bottom, rgb(197 221 120 / 54%), rgb(46 153 183 / 60%));
          width: 100%;
          height: 100%;
        }

        .homepage-parallax section {
          position: initial !important;
        }

        .homepage-parallax section .scroll-wrap {
          padding: 110px 0 !important;
        }

        @media(max-width:982px) {
          .architectpadding {
            padding-top: 80px !important;
          }
        }
          .paginate__item{
          cursor:pointer
          }
      `}</style>
                <div className="animsition animationcss">
                    <header className="header header-3">
                        <div className="header__inner">
                            <a href="/" className="header__logo logo">
                                <span className="logo__image">
                                    <img alt="Architect,Urban Designer,Interior designer" loading="lazy" src={logoimage} className="width60" />
                                </span>
                                <span className="logo__text logocolor">Architect's Design Studio</span>
                            </a>
                        </div>
                    </header>
                    <main>
                        <div className="homepage-parallax">
                            <section className=" single-project single-project--with-sidebar architectpadding paddingtop110">
                                <div className="container-fluid p-0">
                                    <div className="row flex-md-row-reverse no-gutters">
                                        <aside className="single-project__aside col-12 col-md-5 col-lg-4 col-xl-3">
                                            {tbldata &&
                                                (!tbldata.data) ? (
                                                <>
                                                    {/* <div className="norecordcss">
                  <img
                    src={emptyrecord}
                    width="330px"
                    alt="No record found"
                  />
                  <div className="norecordfont">No record found</div>
                </div> */}
                                                </>
                                            ) : (
                                                <>

                                                    <div className="single-project__paginate paginate paginate--arrows">
                                                        <div className="paginate__item paginate__item--prev">
                                                            <a onClick={() => {
                                                                const currentId = Number(tbldata?.data.projects?.projectid);
                                                                const prevId = getPreviousValidId(currentId);
                                                                debouncedEditRecord(prevId);
                                                            }}>
                                                                <svg width="22" height="22" viewBox="0 0 64 64">
                                                                    <path d="M21.1 32L47.2 4.5c1.1-1.1 1.1-2.7 0-3.7s-2.7-1.1-3.7 0L17.4 28.5c-1.9 1.9-1.9 5.1 0 6.9l26.1 27.7c.5.5 1.3.8 1.9.8.5 0 1.3-.3 1.9-.8 1.1-1.1 1.1-2.7 0-3.7L21.1 32z" />
                                                                </svg>
                                                            </a>
                                                        </div>

                                                        <div className="paginate__item paginate__item--all">
                                                            <a href="/#projects">
                                                                <svg width="22" height="22" viewBox="0 0 270 270">
                                                                    <path d="M114 0H10C4.5 0 0 4.5 0 10v104c0 5.5 4.5 10 10 10h104c5.5 0 10-4.5 10-10V10c0-5.5-4.5-10-10-10zm-10 104H20V20h84v84zM260 0H156c-5.5 0-10 4.5-10 10v104c0 5.5 4.5 10 10 10h104c5.5 0 10-4.5 10-10V10c0-5.5-4.5-10-10-10zm-10 104h-84V20h84v84zm-136 42H10c-5.5 0-10 4.5-10 10v104c0 5.5 4.5 10 10 10h104c5.5 0 10-4.5 10-10V156c0-5.5-4.5-10-10-10zm-10 104H20v-84h84v84zm156-104H156c-5.5 0-10 4.5-10 10v104c0 5.5 4.5 10 10 10h104c5.5 0 10-4.5 10-10V156c0-5.5-4.5-10-10-10zm-10 104h-84v-84h84v84z" />
                                                                </svg>
                                                            </a>
                                                        </div>

                                                        <div className="paginate__item paginate__item--next">
                                                            <a onClick={() => {
                                                                const currentId = Number(tbldata?.data.projects?.projectid);
                                                                const nextId = getNextValidId(currentId);
                                                                debouncedEditRecord(nextId);
                                                            }}>
                                                                <svg width="22" height="22" viewBox="0 0 64 64">
                                                                    <path d="M46.8 28.5L20.6.8c-1.1-1.1-2.7-1.1-3.7 0-1.1 1.1-1.1 2.7 0 3.7L42.8 32 16.6 59.5c-1.1 1.1-1.1 2.7 0 3.7.5.5 1.1.8 1.9.8s1.3-.3 1.9-.8l26.1-27.7c2.1-1.9 2.1-5.1.3-7z" />
                                                                </svg>
                                                            </a>
                                                        </div>
                                                    </div>

                                                    <div className="single-project__aside-content">
                                                        <h1 className="single-project__heading heading" data-aos="fade-up">
                                                            {tbldata?.data.projects?.title}
                                                        </h1>
                                                        <div className="single-project__short">{tbldata?.data.projects?.subtitle}</div>

                                                        <ul className="single-project__meta project-meta project-meta--table">
                                                            <li className="project-meta__item" data-aos="fade-up">
                                                                <div className="project-meta__item-title">Client</div>
                                                                <div className="project-meta__item-text">
                                                                    {tbldata?.data.projects?.clientname || "N/A"}
                                                                </div>
                                                            </li>

                                                            <li className="project-meta__item" data-aos="fade-up">
                                                                <div className="project-meta__item-title">Services</div>
                                                                <div className="project-meta__item-text">
                                                                    {tbldata?.data.projects?.services}
                                                                </div>
                                                            </li>

                                                            <li className="project-meta__item" data-aos="fade-up">
                                                                <div className="project-meta__item-title">Location</div>
                                                                <div className="project-meta__item-text">
                                                                    {tbldata?.data.projects?.location}
                                                                </div>
                                                            </li>

                                                            <li className="project-meta__item" data-aos="fade-up">
                                                                <div className="project-meta__item-title">Date</div>
                                                                <div className="project-meta__item-text">
                                                                    {tbldata?.data.projects?.projectdate}
                                                                </div>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </>
                                            )}
                                        </aside>
                                        <div className="single-project__content col-12 col-md-7 col-lg-8 col-xl-9">
                                            <div className="single-project__gallery positionrelative">
                                                {Array.from({ length: Number(tbldata?.data.projects?.totalphotos || 0) }, (_, i) => {
                                                    const photoIndex = i + 1;
                                                    const imageUrl = `/img/large/${tbldata?.data.projects?.projectid}/${photoIndex}.jpg`;

                                                    return (
                                                        <div key={photoIndex} className="single-project__gallery-item" data-aos="fade-up">
                                                            <img src={imageUrl} alt={`${tbldata?.data.projects?.title} - Photo ${photoIndex}`} />
                                                            <div
                                                                style={{
                                                                    position: 'absolute',
                                                                    top: 0,
                                                                    left: 0,
                                                                    width: '100%',
                                                                    height: '100%',
                                                                    zIndex: 2,
                                                                }}
                                                                onContextMenu={(e) => e.preventDefault()}
                                                            ></div>
                                                            <div className="top-left">
                                                                <img alt="Architect,Urban Designer,Interior designer" loading="lazy" className="watermark2" src={logoimage} />
                                                            </div>
                                                        </div>
                                                    );
                                                })}
                                            </div>


                                        </div>
                                    </div>
                                </div>
                            </section>




                            <section id="contactus" className="section pp-scrollable  our-story our-story--different dark backmargin">
                                <div className="scroll-wrap">
                                    <div className="container">
                                        <div className="row">
                                            <div className="col-12 col-lg-6">
                                                <div className="feedback-form__title colorwhite">
                                                    Contact us
                                                </div>
                                                <div className="contact-block">
                                                    <h2 className="contact-block__title">
                                                        Surat, <span className="colorwhite">Gujarat</span>
                                                    </h2>
                                                    <address className="contact-block__address">414-Oberon, opp. Mercedes benz showroom, New City Light, Surat, Gujarat 395007 </address>
                                                    <div className="contact-block__email">
                                                        <span className="contact-block__hint">Email:</span>
                                                        <a href="mailto:vk.adsarchitects@gmail.com"><span className="__cf_email__ fontsize16">vk.adsarchitects@gmail.com</span></a>
                                                    </div>
                                                    <div className="contact-block__phone">
                                                        <span className="contact-block__hint colorwhite">Call directly:</span>
                                                        <a href="tel:+919033718216" className="fontsize18">+91 90337 18216</a>
                                                        <br />
                                                        <span className="colorback">OR</span> <a href="tel:02613696240" className="displayinline18">0261 3696240</a>

                                                    </div>
                                                    <div className="contact-block__offices">
                                                        <span className="contact-block__hint">Brand Offices:</span>
                                                        <div className="contact-block__offices-list">
                                                            <a className="contact-block__offices-item" href="#">Surat Gujarat</a>
                                                            <a className="contact-block__offices-item" href="#">Ahmedabad, Gujarat</a>

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-12 col-lg-6">


                                                <div className="contacts-different__feedback feedback-form js-form-validate paddingtop45">


                                                    <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d14884.409828114432!2d72.7985076!3d21.1483205!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x22145bfcf6ace00c!2sADS%20Architects%20%26%20Interior%20designer!5e0!3m2!1sen!2sin!4v1660302625977!5m2!1sen!2sin" className="iframecss" allowfullscreen="" referrerpolicy="no-referrer-when-downgrade"></iframe>


                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>

                        </div>

                    </main>

                    <footer className="footer-3">

                        <ul className="footer-3__socials">
                            <li>
                                <a href="https://www.facebook.com/ADSArchitectsDesignStudio" target="_blank">
                                    <svg width="14" height="14" viewBox="0 0 64 64">
                                        <path d="M47.9 25.6H40V15h6.5c1.1 0 2-.9 2-2V2c0-1.1-.9-2-2-2h-7.6C30.7 0 25 5.9 25 14.4v11.2h-9c-1.5 0-2.7 1.2-2.7 2.8v7.4c0 1.5 1.2 2.7 2.7 2.7h9v22.9c0 1.5 1.2 2.7 2.7 2.7h9.8c.6 0 1.2-.3 1.6-.7.5-.5.7-1.2.7-1.8V38.4h6.8c1.3 0 2.4-.9 2.6-2.1v-.2l1.4-7.1c.2-.8 0-1.6-.6-2.4-.4-.5-1.2-.9-2.1-1z" />
                                    </svg>
                                </a>
                            </li>
                            <li>
                                <a href="https://www.linkedin.com/in/architect-s-design-studio-ads/" target="_blank">

                                    <svg width="14" height="14" version="1.1" id="Layer_1" x="0px" y="0px"
                                        viewBox="0 0 310 310" className="svgback" >
                                        <g id="XMLID_801_">
                                            <path id="XMLID_802_" d="M72.16,99.73H9.927c-2.762,0-5,2.239-5,5v199.928c0,2.762,2.238,5,5,5H72.16c2.762,0,5-2.238,5-5V104.73
		C77.16,101.969,74.922,99.73,72.16,99.73z" />
                                            <path id="XMLID_803_" d="M41.066,0.341C18.422,0.341,0,18.743,0,41.362C0,63.991,18.422,82.4,41.066,82.4
		c22.626,0,41.033-18.41,41.033-41.038C82.1,18.743,63.692,0.341,41.066,0.341z" />
                                            <path id="XMLID_804_" d="M230.454,94.761c-24.995,0-43.472,10.745-54.679,22.954V104.73c0-2.761-2.238-5-5-5h-59.599
		c-2.762,0-5,2.239-5,5v199.928c0,2.762,2.238,5,5,5h62.097c2.762,0,5-2.238,5-5v-98.918c0-33.333,9.054-46.319,32.29-46.319
		c25.306,0,27.317,20.818,27.317,48.034v97.204c0,2.762,2.238,5,5,5H305c2.762,0,5-2.238,5-5V194.995
		C310,145.43,300.549,94.761,230.454,94.761z" />
                                        </g>
                                        <g>
                                        </g>
                                        <g>
                                        </g>
                                        <g>
                                        </g>
                                        <g>
                                        </g>
                                        <g>
                                        </g>
                                        <g>
                                        </g>
                                        <g>
                                        </g>
                                        <g>
                                        </g>
                                        <g>
                                        </g>
                                        <g>
                                        </g>
                                        <g>
                                        </g>
                                        <g>
                                        </g>
                                        <g>
                                        </g>
                                        <g>
                                        </g>
                                        <g>
                                        </g>
                                    </svg>

                                </a>
                            </li>
                            <li>
                                <a href="https://www.instagram.com/adsarchitects2020/" target="_blank">
                                    <svg width="14" height="14" viewBox="0 0 64 64">
                                        <path d="M32 16.9c-8.3 0-15 6.8-15 15.1s6.7 15.1 15 15.1S47 40.3 47 32s-6.7-15.1-15-15.1zm0 25.2c-5.5 0-10-4.5-10-10.1s4.5-10.1 10-10.1S42 26.4 42 32s-4.5 10.1-10 10.1zM47 10c-2.8 0-5 2.3-5 5s2.2 5 5 5 5-2.3 5-5-2.2-5-5-5z" />
                                        <path d="M48 0H16C7.2 0 0 7.2 0 16v31.7C0 56.7 7.3 64 16.3 64h31.5C56.7 64 64 56.7 64 47.7V16c0-8.8-7.2-16-16-16zm11 47.7C59 53.9 54 59 47.8 59H16.3C10.1 59 5 54 5 47.8V16C5 9.9 9.9 5 16 5h32c6.1 0 11 4.9 11 11v31.7z" />
                                    </svg>
                                </a>
                            </li>
                        </ul>

                        <div className="footer-3__copyrights">
                            <a href="https://wa.me/919033718216?text=I'd%20like%20to%20connect" target="_blank" className="floatleft wpbtn">

                                <img alt="Architect,Urban Designer,Interior designer" loading="lazy" className="my-float wpbtn2" src={imgwhatsapp} />


                            </a>
                            <p>
                                ©

                                <script>
                                    document.write(new Date().getFullYear())
                                </script>
                                ADS

                            </p>
                            <p>All Rights Reserved</p>
                        </div>
                    </footer>
                </div>


            </>
        </>
    );
};
export default SingleProject;